// extracted by mini-css-extract-plugin
export default {"component":"container_component__DSXHe"};